import React, { Component, createRef, Fragment } from "react";
import {
  Hero,
  Title,
  TechniqueTitle,
  ClientTag,
  CaseWrapper,
  BackButton,
  BackArrow
} from "../styles/Case.styles";

import Reveal from 'react-reveal/Reveal';
import { withRouter } from "react-router";
import Footer from '../components/Footer';
import { Efectr, Efectr1, Efectr2  } from "../styles/effect.styles";

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location])
  return children
}

class Case extends Component {
  constructor(props) {
    super(props);
    this.introRef = createRef();

    this.state = {
          toBack: false,
          introTop: 0,
          hasBackground: false,
          animateCase: ""
        };
      }
    
      componentDidUpdate() {
        if (this.state.toBack) {
          setTimeout(() => {
            this.props.setNavBackground(false);
            this.props.history.push("/blog");
          }, 400);
        }
        if (this.state.animateCase) {
          setTimeout(() => {
            this.props.setNavBackground(false);
    
            this.props.history.push(this.state.animateCase);
            window.scrollTo(0, 0);
          }, 400);
        }
      }
    
    
      render() {
        return (
          <Fragment>
          <Efectr/>
          <Efectr1/>
          <Efectr2/>
          <ScrollTop>
            <CaseWrapper>
              <Reveal effect="fadeIn">
                <Hero className='mainhero' style={{ backgroundImage: "url('./img/feature/img7.jpg')" }}>
                    <div className='herocaption'>
                      <BackButton className='backdetail'
                        onClick={() => this.setState({ toBack: true, hasBackground: false })}
                        toBack={this.state.toBack}
                        hasBackground={this.state.hasBackground}>
                        <BackArrow src="./img/back.png" alt="Back to blog" />
                        <span>Back </span>
                      </BackButton>
                      <div className='container'>
                        <div className='row'>
                          <div className='col-md-12 pl-md-0'>
                            <ClientTag className='date'>March 25, 2024</ClientTag>
                            <Title>Forget Me? Not!</Title>
                            <TechniqueTitle>
                            Alzheimer's Disease may be Diabetes Type III 
                            </TechniqueTitle>
                          </div>
                        </div>
                      </div>
                    </div>
                </Hero>
              </Reveal>
    
              <section className='container' id='detailproject'>
                <div className='row'>
                  <div className='col-md-12'>
                    <p className='content'>Alzheimer’s disease is a progressive 
                        brain disorder that gradually destroys memory and cognitive 
                        functions. It is the most common cause of dementia among 
                        older adults. Symptoms worsen over time, impacting daily 
                        life and eventually leading to the inability to carry out 
                        even the simplest of tasks.</p>
                    <p className='content'>Conversely, diabetes is a chronic metabolic 
                        disorder characterized by high blood sugar levels, stemming 
                        from either insufficient insulin production (Type 1) or 
                        ineffective use of insulin by the body (Type 2). </p>
                    <p className='content'>It is still in debate for the exact 
                        connect between Alzheimer’s disease and diabetes. However, 
                        recent studies propose a correlation between Alzheimer’s 
                        disease and insulin resistance in the brain, parallel to 
                        the mechanisms underlying diabetes. Insulin plays a crucial 
                        role in cognitive processes like memory and learning. 
                        Compromised brain insulin sensitivity can lead to disruption 
                        in central insulin signalling, accumulation of neurotoxins, 
                        neuronal stress, and ultimately, neurodegeneration. </p>

                  
                    <h3 className='my-5'>How to Minimize Risk of Alzheimer's Disease</h3>
                    <div>
                      <p className='content'>1. Exercise: Regular exercise has been shown to ensure adequate blood flow to the brain, release brain derived neurotropic factor (BDNF) which supports the growth and maintenance of brain cells and reduce inflammation and oxidative stress.</p>
                      <p className='content'> 2. Eat an Anti-Inflammatory Diet: Eat more whole foods and less processed foods. Consume foods rich in protein, fats and complex carbohydrates. Limit your intake of simple sugars. </p>
                      <p className='content'>3. Supplements: Vitamin D3, Omega-3s.</p>
                      <p className='content'> 4. Expert help: Speak with your Naturopathic Doctor to learn more about reducing the risk of Alzheimer’s Disease!</p>
                    </div>
                  </div>  

                  <div className='col-md-12'></div>
                  <div className='share'>
                    <span className='heading'>
                    Share this blog post :
                    </span>
                    <span className='content'> 
                    <a href="https://www.facebook.com/sharer/sharer.php?u=drmichellemaliknd.com/WOW2" target="_blank" rel="noopener noreferrer">  
                      <i className="fa fa-facebook-f"></i>
                      </a>  
                    </span>
                    <span className='content'> 
                    <a href="https://www.instagram.com/dr.michellemalik.nd" target="_blank" rel="noopener noreferrer">   
                      <i className="fa  fa-instagram"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </section>

            </CaseWrapper>
    
          </ScrollTop>
    
          <Footer />
    
          </Fragment>
        );
      }
    }
    
    export default withRouter(Case);